/** The Permissive component is responsible for encouraging & prompting users to install PWA */
const Permissive = ({
    onOpen = () => {},
    getClassesFrom = ({ small = '', medium = '', large = ''} = {}) => {},
} = {}) => {
    return {
        deferredPrompt: undefined,
        isInstalledPWA: Alpine.$persist(false).as('isInstalledPWA'),
        canManagePWA: typeof window.onbeforeinstallprompt == 'object',
        viewedStepByStepPWA: {
            // iphone and ipad is not handled by permissive component.
            // however, we need to define the same storage as unpermissive step-by-step.
            chrome: Alpine.$persist({ android: [], iphone: [], ipad: [] }).as('viewedStepByStepPWA.chrome'),
        },
        open: false,
        onClose: undefined,
        onOpen,
        getClassesFrom,

        init(){
            this.$watch('open', (value) => {
                if(value){
                    this.$dispatch('disable-scroll');
                    return;
                }

                this.onClose();

                this.viewedStepByStepPWA.chrome.android.push(new Date());

                this.$dispatch('enable-scroll');
            });
        },

        get isPWA() {
            return ['standalone', 'minimal-ui', 'fullscreen'].some(
                (displayMode) => window.matchMedia(`(display-mode:${displayMode})`).matches
            );
        },

        get isLandscapeView() {
            return window.matchMedia('(orientation: landscape)').matches;
        },

        async handleInstallPWA(){
            if(this.deferredPrompt === undefined){
                return;
            }

            await this.deferredPrompt.prompt();

            const { outcome } = await this.deferredPrompt.userChoice;

            if(outcome === 'accepted'){
                this.isInstalledPWA = true;
                this.deferredPrompt = undefined;
            }
        },

        browserHandler(){
            const { callback } = this.$event.detail;

            this.onClose = callback;

            if(this.isLandscapeView) {
                callback();

                return;
            }

            if(this.isPWA){
                this.viewedStepByStepPWA.chrome.android.length == 0 && viewedStepByStepPWA.chrome.android.push(new Date());
                callback();

                return;
            }

            if (this.viewedStepByStepPWA.chrome.android.length === 1){
                callback();

                return;
            }

            if(!this.canManagePWA || typeof this.deferredPrompt === 'undefined'){
                callback();

                return;
            }

            this.open = true;
            typeof this.onOpen === 'function' && this.onOpen();
            this.$dispatch('disable-scroll');
        },

        android: {
            ['x-on:encourage-usage-of-pwa-on-android-from-chrome.window']() {
                this.browserHandler();
            },
            ['x-on:beforeinstallprompt.window']() {
                this.deferredPrompt = this.$event;
                this.isInstalledPWA = false;
            },
            ['x-on:appinstalled.window']() {
                this.isInstalledPWA = true;
                this.open = false;
            },
        },
    };
};

/** The Unpermissive component is responsible for encouraging users to install PWA. */
const Unpermissive = ({
    device,
    onOpen = () => {},
    getClassesFrom = ({ small = '', medium = '', large = ''} = {}) => {},
} = {}) => {
    return {
        viewedStepByStepPWA: {
            chrome: Alpine.$persist({ android: [], iphone: [], ipad: [] }).as('viewedStepByStepPWA.chrome'),
            safari: Alpine.$persist({ iphone: [], ipad: [] }).as('viewedStepByStepPWA.safari'),
        },
        browser: 'safari',
        open: false,
        step: 'info',
        onClose: undefined,
        device,
        onOpen,
        getClassesFrom,

        init(){
            this.$watch('browser', (value) => {
                if(!['chrome', 'safari'].includes(value)){
                    throw new Error('Invalid browser.');
                }
            });

            this.$watch('device', (value) => {
                if(!['iphone', 'ipad'].includes(value)){
                    throw new Error('Invalid device.');
                }
            });

            this.$watch('open', (value) => {
                if(value){
                    this.$dispatch('disable-scroll');
                    return;
                }

                this.onClose();

                this.viewedStepByStepPWA[this.browser][this.device].push(new Date());

                this.$dispatch('enable-scroll');
            });
        },

        iphone: {
            ['x-on:encourage-usage-of-pwa-on-iphone-from-safari.window']() {
                this.browser = 'safari';
                this.browserHandler();
            },
            ['x-on:encourage-usage-of-pwa-on-iphone-from-chrome.window']() {
                this.browser = 'chrome';
                this.browserHandler();
            },
        },

        ipad: {
            ['x-on:encourage-usage-of-pwa-on-ipad-from-safari.window']() {
                this.browser = 'safari';
                this.browserHandler();
            },
            ['x-on:encourage-usage-of-pwa-on-ipad-from-chrome.window']() {
                this.browser = 'chrome';
                this.browserHandler();
            },
        },

        get isPWA() {
            return ['standalone', 'minimal-ui', 'fullscreen'].some(
                (displayMode) => window.matchMedia(`(display-mode:${displayMode})`).matches
            );
        },

        get isLandscapeView() {
            return window.matchMedia('(orientation: landscape)').matches;
        },

        browserHandler(){
            const { callback } = this.$event.detail;

            this.onClose = callback;

            if(this.isLandscapeView) {
                callback();

                return;
            }

            if(this.isPWA){
                this.viewedStepByStepPWA[this.browser][this.device].push(new Date());
                callback();

                return;
            }

            if (this.viewedStepByStepPWA[this.browser][this.device].length === 1){
                callback();

                return;
            }

            this.open = true;
            typeof this.onOpen === 'function' && this.onOpen();
            this.$dispatch('disable-scroll');
        },
    };
};

export default { Unpermissive, Permissive };
